import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.jpg'
import { FaBars, FaUser } from 'react-icons/fa';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaBell } from 'react-icons/fa';
import { FaCog } from 'react-icons/fa';
import { FaSignOutAlt } from 'react-icons/fa';

interface HeaderSectionProps {
    onToggleSidebar: () => void;
  }
  
  const HeaderSection: React.FC<HeaderSectionProps> = ({ onToggleSidebar }) => {
  const [currentDateTime, setCurrentDateTime] = useState<string>('');
  const [username] = useState('Keshava Prabha'); // Replace with actual logged-in user name
  const [officeLocation] = useState('Head Office'); // Replace with actual office location

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      setCurrentDateTime(formattedDateTime);
    }, 1000);
  
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);


  return (
    <div className="navbar navbar-expand-lg sticky-top header-container" style={{position:"fixed"}}>
      <div className="logo-container">
        <div className="logo">
          <img src={logo} alt="Logo" width={200} />
        </div>
        <button className="toggle-sidebar" onClick={onToggleSidebar}>
          <FaBars color='orange'/>
        </button>
      </div>     
      <div className="header-items">    
        <div className="current-date-time">{currentDateTime}</div>
        <div className="user-info">
        <FaUser className="user-icon" />
        <div className="user-details">
          <div className="username">{username}</div>
          <div className="user-role">Admin</div>
        </div>
      </div>
        <div className="office-location">
          <FaMapMarkerAlt color='orange' fontSize={25}/>
          <div className="user-details">
          <div className="username">{officeLocation}</div>
          <div className="user-role">Branch</div>
        </div>
        </div>
        <button className="notification-icon">
          <FaBell color='red' fontSize={20}/>
        </button>
        <button className="settings-icon">
          <FaCog color='orange'fontSize={20}/>
        </button>
        <button className="logout-button" onClick={() => {
          localStorage.removeItem('token');
          window.location.reload();
        }}>
          <FaSignOutAlt color='orange' fontSize={20}/>
        </button>
      </div>
    </div>
  );
};

export default HeaderSection;
